export default "__VITE_ASSET__CipXRnUe__"